var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#D2D2D2;}\n\t.st2{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2993;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#BABABA;stroke-width:2.2993;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#CFCFCF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.7,102.8c-19.3,0-38.8-0.8-57.2-5.9c-18-5-34.5-14.7-49.2-25.9C94.7,63.8,86,58,73.5,58.8 c-12.2,0.7-23.9,5.3-33.4,13.1c-15.9,13.9-13.5,39.7-7.2,57.8c9.6,27.3,38.7,46.3,63.4,58.6c28.6,14.3,60,22.5,91.5,27.3 c27.6,4.2,63,7.2,86.9-10.8c22-16.6,28-54.4,22.6-79.9c-1.3-7.5-5.3-14.3-11.3-19.1c-15.4-11.3-38.4-3.7-55.8-3.4 C223.9,102.8,217.3,102.8,210.7,102.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.6,260.5c46.6,0,84.4-2.4,84.4-5.3c0-2.9-37.8-5.3-84.4-5.3c-46.6,0-84.4,2.4-84.4,5.3 C79.2,258.1,117,260.5,163.6,260.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.9,25.2c-0.8-4.3,0.1-8.7,2.5-12.3c2.4-3.6,6.2-6.1,10.5-6.9h0.4c4.3-0.8,8.7,0.1,12.3,2.5 s6.1,6.2,6.9,10.5L111.9,25.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.6,32.3l107.2-20.4c5.2-1,10.6,0.1,15,3.1c4.4,3,7.4,7.6,8.4,12.8L58.7,55.7c-1-5.2,0.1-10.6,3.1-15 C64.8,36.3,69.4,33.3,74.6,32.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.6,57.2l162.6-30.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.2,185l-79.6,55c-2.1,1.5-4.7,2.1-7.3,1.7c-2.6-0.4-4.9-1.7-6.5-3.7L90.2,126.3l111.6-77.2l73.3,122.2 c1.3,2.2,1.8,4.9,1.2,7.5C275.9,181.3,274.4,183.6,272.2,185z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.4,135.3l137.4-95.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.6,104.7L140.6,104.7c-1.8,1.3-2.2,3.8-0.9,5.6l71.6,99.1c1.3,1.8,3.8,2.2,5.6,0.9l0,0 c1.8-1.3,2.2-3.8,0.9-5.6l-71.6-99.1C144.9,103.8,142.4,103.4,140.6,104.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.5,197L236.5,197c1.9-1.2,2.4-3.7,1.1-5.6L170.4,90c-1.2-1.8-3.7-2.3-5.6-1.1l0,0c-1.8,1.2-2.3,3.7-1.1,5.6 l67.2,101.5C232.1,197.7,234.6,198.2,236.5,197z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186,73.4L186,73.4c-1.9,1.2-2.5,3.7-1.3,5.6l64.4,103.9c1.2,1.9,3.7,2.5,5.5,1.3l0,0c1.9-1.2,2.5-3.7,1.3-5.5 L191.5,74.7C190.4,72.8,187.9,72.2,186,73.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.8,223.4L197.8,223.4c1.8-1.4,2.1-3.9,0.8-5.7L124,120.9c-1.4-1.8-3.9-2.1-5.6-0.7l0,0 c-1.8,1.4-2.1,3.9-0.7,5.6l74.5,96.9C193.5,224.4,196,224.7,197.8,223.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228.5,52c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C226.2,51,227.2,52,228.5,52z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.2,39.4c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C50,38.4,51,39.4,52.2,39.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.6,230.7c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3S231.4,230.7,232.6,230.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.2,59.1v9.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.3,64h9.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104,195.7v9.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99,200.7h9.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.1,79v9.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.1,83.9h9.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTrash);
export default __webpack_public_path__ + "static/media/no-trash.e0671f0e9ec6ef5a8c3798c4c158144e.svg";
export { ForwardRef as ReactComponent };